import React from 'react';
import { Space } from 'antd';
export default function PageHeader({ title, subtitle, actions }) {
  return (
    <div className="page-header">
      <div>
        <h2>{title}</h2>
        {subtitle && <p>{subtitle}</p>}
      </div>
      {actions && <Space>{actions}</Space>}
    </div>
  );
}
